export default "__VITE_ASSET__QHGzkmi3__"